import { Timestamp } from '../Timestamp'

export type ProposalDecision = 'for' | 'against' | 'withdrawn'

export interface ProposalOutcome {
  decision?: ProposalDecision
  votes?: ProposalOutcomeVotes
  createTime?: Timestamp
}

export interface ProposalOutcomeVotes {
  // Todo Rename and don't use keyword
  for?: number
  against?: number
  abstain?: number
  brokerNonVote?: number
  withheld?: number
}

/**
 * totalVotes returns the total vote count in a proposal oiutc
 */
export const totalVotes = (proposal: ProposalOutcomeVotes): number =>
  [proposal.for, proposal.against, proposal.abstain, proposal.brokerNonVote, proposal.withheld].reduce<number>(
    (acc, value): number => {
      if (value === undefined) {
        return acc
      }
      return acc + value
    },
    0
  )
